import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'displayAddress' })
export class DisplayAddressPipe implements PipeTransform {

  transform(value: any): any {
    if (!value) {
      return;
    }

    const { address1, address2, city, state, zipcode } = value.address;

    return `${ address1 } ${ address2 }, ${ city }, ${ state }, ${ zipcode }`;
  }

}
